import { MediaQueries } from '@hhgtech/hhg-components'
import { themeColors } from '@hhgtech/hhg-components/mantine'
import {
  Box,
  Container,
  ContainerProps,
  Divider,
  Grid,
  Stack,
} from '@mantine/core'

import { getHelloSitesUrl } from 'api/utils/paths'
import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { Article } from 'interfaces/types'
import { RequireAll } from 'interfaces/types/Utilities'

type _GridArticleProps = {
  articles?: Array<Article>
} & ContainerProps

const _NormalGrid = ({
  articles,
  ...rest
}: RequireAll<_GridArticleProps, 'articles'>) => {
  const { locale } = useRouterExtend()
  const isMobile = useIsMobile()
  return (
    <Container fluid p={0} mx={0} w="100%" {...rest}>
      <Grid columns={12} gutter={0} gutterMd={'xl'}>
        <Grid.Col span={12} md={7}>
          <ArticleCardWrapper
            article={articles[0]}
            dataEventCategoryForTitle="Top Article Title"
            dataEventActionForTitle={`Click ${1}`}
            dataEventLabelForTitle={`${getHelloSitesUrl(locale)}${
              articles[0].permalinkDecode
            }`}
            dataEventCategoryForBanner="Top Article Banner"
            dataEventActionForBanner={`Click ${1}`}
            dataEventLabelForBanner={`${getHelloSitesUrl(locale)}${
              articles[0].permalinkDecode
            }`}
            dataEventCategoryForCategory="Top Category Title"
            dataEventActionForCategory={`Click ${1}`}
            dataEventLabelForCategory={`${getHelloSitesUrl(locale)}${
              articles[0].category.permalinkDecode
            }`}
            // ={true}
            type="author"
            size={isMobile ? 'sm' : 'md'}
            direction="vertical"
          />
        </Grid.Col>
        {isMobile && (
          <Grid.Col>
            <Divider variant="dashed" color="neutral.1" my={16} />
          </Grid.Col>
        )}
        <Grid.Col span={12} md={5}>
          <Stack align="space-between" spacing={isMobile ? 0 : 16}>
            {/* Prevent out of articles */}
            {articles.slice(1, 3).map((article, idx) => (
              <Box
                key={article.id}
                sx={{
                  ...(idx === 0
                    ? {
                        article: {
                          padding: '0 0 10px 0 !important',
                          [MediaQueries.mbUp]: {
                            ['.banner']: {
                              minHeight: '300px',
                              maxHeight: '300px',
                            },
                          },
                        },
                      }
                    : {}),
                  ...(idx === 1
                    ? {
                        [MediaQueries.mbUp]: {
                          article: {
                            flexDirection: 'row-reverse',
                            gap: 16,
                            padding: 0,
                          },
                        },
                        article: {
                          padding: '10px 0 !important',
                          [MediaQueries.mbDown]: {
                            borderBottom: `1px dashed ${themeColors.neutral[1]}`,
                          },
                        },
                      }
                    : {}),
                }}
              >
                <ArticleCardWrapper
                  article={article}
                  dataEventCategoryForTitle="Top Article Title"
                  dataEventActionForTitle={`Click ${idx + 2}`}
                  dataEventLabelForTitle={`${getHelloSitesUrl(locale)}${
                    article.permalinkDecode
                  }`}
                  dataEventCategoryForCategory="Top Category Title"
                  dataEventActionForCategory={`Click ${idx + 2}`}
                  dataEventLabelForCategory={`${getHelloSitesUrl(locale)}${
                    article.category.permalinkDecode
                  }`}
                  dataEventCategoryForBanner="Top Article Banner"
                  dataEventActionForBanner={`Click ${idx + 2}`}
                  dataEventLabelForBanner={`${getHelloSitesUrl(locale)}${
                    article.permalinkDecode
                  }`}
                  type="author"
                  size="sm"
                  direction={
                    idx === 0
                      ? isMobile
                        ? 'horizontal'
                        : 'vertical'
                      : 'horizontal'
                  }
                  text=""
                  bannerImageWrapProps={
                    {
                      'data-event-category': 'Top Article Banner',
                      'data-event-action': `Click ${idx + 2}`,
                      'data-event-label': `${getHelloSitesUrl(locale)}${
                        article.permalinkDecode
                      }`,
                    } as any
                  }
                />
                {idx === 0 && <Divider variant="dashed" color="neutral.1" />}
              </Box>
            ))}
          </Stack>
        </Grid.Col>

        {!isMobile && (
          <Grid.Col>
            <Divider variant="dashed" color="neutral.1" />
          </Grid.Col>
        )}
        {articles.slice(3).map((article, idx) => (
          <>
            <Grid.Col
              span={12}
              md={3}
              key={article.id}
              sx={{
                paddingBlock: '20px !important',
                borderBottom: `1px dashed ${themeColors.neutral[1]}`,
                [MediaQueries.mbDown]: {
                  paddingBlock: '16px !important',
                  borderBottom:
                    idx + 3 < articles.length - 1
                      ? `1px dashed ${themeColors.neutral[1]}`
                      : undefined,
                },
              }}
            >
              <Box
                sx={{
                  article: {
                    [MediaQueries.mbDown]: {
                      padding: '0 !important',
                    },
                  },
                }}
              >
                <ArticleCardWrapper
                  article={article}
                  dataEventCategoryForTitle="Top Article Title"
                  dataEventActionForTitle={`Click ${idx + 4}`}
                  dataEventLabelForTitle={`${getHelloSitesUrl(locale)}${
                    article.permalinkDecode
                  }`}
                  dataEventCategoryForBanner="Top Article Banner"
                  dataEventActionForBanner={`Click ${idx + 4}`}
                  dataEventLabelForBanner={`${getHelloSitesUrl(locale)}${
                    article.permalinkDecode
                  }`}
                  dataEventCategoryForCategory="Top Category Title"
                  dataEventActionForCategory={`Click ${idx + 4}`}
                  dataEventLabelForCategory={`${getHelloSitesUrl(locale)}${
                    article.category.permalinkDecode
                  }`}
                  type="author"
                  size="sm"
                  direction={isMobile ? 'horizontal' : 'vertical'}
                  bannerImageWrapProps={
                    {
                      'data-event-category': 'Top Article Banner',
                      'data-event-action': `Click ${idx + 4}`,
                      'data-event-label': `${getHelloSitesUrl(locale)}${
                        article.permalinkDecode
                      }`,
                    } as any
                  }
                  text=""
                />
              </Box>
            </Grid.Col>
          </>
        ))}
      </Grid>
    </Container>
  )
}
const _Stacking = ({
  articles,
  ...rest
}: RequireAll<_GridArticleProps, 'articles'>) => {
  const { locale } = useRouterExtend()
  const isMobile = useIsMobile()
  return (
    <Container fluid p={0} mx={0} w="100%" {...rest}>
      <Stack>
        {articles.map((article, idx) => (
          <Box
            key={article.id}
            sx={{
              // [MediaQueries.mbDown]: {
              [MediaQueries.mbUp]: {
                article: {
                  padding: '0 !important',
                  ['.banner']: {
                    minWidth: '264px',
                    maxWidth: '264px',
                    minHeight: '176px',
                    maxHeight: '1176px',
                  },
                  ['.footer']: {
                    marginTop: 'initial !important',
                  },
                },
              },
              // },
            }}
          >
            <ArticleCardWrapper
              article={article}
              dataEventCategoryForTitle="Top Article Title"
              dataEventActionForTitle={`Click ${idx + 4}`}
              dataEventLabelForTitle={`${getHelloSitesUrl(locale)}${
                article.permalink
              }`}
              dataEventCategoryForBanner="Top Article Banner"
              dataEventActionForBanner={`Click ${idx + 4}`}
              dataEventLabelForBanner={`${getHelloSitesUrl(locale)}${
                article.permalinkDecode
              }`}
              dataEventCategoryForCategory="Top Category Title"
              dataEventActionForCategory={`Click ${idx + 4}`}
              dataEventLabelForCategory={`${getHelloSitesUrl(locale)}${
                article.category.permalinkDecode
              }`}
              type="author"
              size={idx === 0 && isMobile ? 'lg' : 'sm'}
              direction={idx === 0 && isMobile ? 'vertical' : 'horizontal'}
              bannerImageWrapProps={
                {
                  'data-event-category': 'Top Article Banner',
                  'data-event-action': `Click ${idx + 4}`,
                  'data-event-label': `${getHelloSitesUrl(locale)}${
                    article.permalinkDecode
                  }`,
                } as any
              }
              text=""
            />
          </Box>
        ))}
      </Stack>
    </Container>
  )
}
export const _GridArticle = (props: _GridArticleProps) => {
  const { articles } = props
  if (!articles || articles.length === 0) return null
  if (articles.length >= 3) {
    return <_NormalGrid {...props} articles={articles} />
  } else {
    return <_Stacking {...props} articles={articles} />
  }
}
